
import { mapGetters, mapActions } from 'vuex'
import productData from '@/data/products.json'

const PREREQ_PRODUCT_ID = '10192'

export default {
  name: 'BookButton',
  props: {
    product_id: { type: String },
    uri: { type: String },
    classroom_id: { type: Number, default: null },
    center: { type: String, default: '' },
    pageId: { type: String },
    virtual: { type: String },
    hidden: { type: String, default: 'false' },
    virtual_toggle: { type: String },
    button_text: { type: String },
    buttonclass: { type: String, default: 'large' }
  },
  data() {
    return {
      pageid: '',
      classroom: null,
      isLoading: false,
      showPrereqConfirm: false,
      pendingPriceData: null // holds priceData while awaiting confirmation
    }
  },
  fetchKey: 'classrooms-button',
  computed: {
    ...mapGetters({
      length: 'cart/getNumberOfProducts',
      showModal: 'cart/showAdded'
    }),
    product() {
      const pid =
        this.$props.product_id ||
        this.$page && this.$page.productId ||
        this.$store.state.pages.page.productId

      const getProduct = productData.find((o) => o.id.toString() === pid) || {}
      getProduct.classroomId = this.$props.classroom_id || null
      return getProduct
    },
    priceData() {
      return this.$options.filters.priceData(this.product)
    },
    // True if this button requires a prerequisites confirmation
    requiresPrereqConfirm() {
      return this.product && this.product.id && this.product.id.toString() === PREREQ_PRODUCT_ID
    }
  },
  methods: {
    ...mapActions({
      addToCart: 'cart/addToCartServer'
    }),
    handleBookClick(data) {
      if (this.requiresPrereqConfirm) {
        // Hold the price data and show confirmation before proceeding
        this.pendingPriceData = data
        this.showPrereqConfirm = true
      } else {
        this.addToCartLoading(data)
      }
    },
    confirmAndProceed() {
      this.showPrereqConfirm = false
      this.addToCartLoading(this.pendingPriceData)
      this.pendingPriceData = null
    },
    addToCartLoading(data) {
      this.isLoading = true
      return this.addToCart(data).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.log(err)
        this.isLoading = false
      })
    }
  }
}
